import { object, string } from "yup";

export const adHocScopeChange = object({
  scopeOfWork: string().required("Required"),
  amount: string().required("Required"),
});
